export default Object.freeze({
	acRefundAssist: 131072
});
